var getErrorMessageFromApiError = function (e) { var _a, _b, _c; return ((_a = e === null || e === void 0 ? void 0 : e.body) === null || _a === void 0 ? void 0 : _a.message) || ((_c = (_b = e === null || e === void 0 ? void 0 : e.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message); }; // CT // WebApp

export { getErrorMessageFromApiError };
//# sourceMappingURL=api.js.map
